<template>
  <v-card
      :class="[newMessageClass, additionalClass]"
      :color="bgColor"
      :id="message.id"
      outlined
  >
    <v-card-subtitle class="d-flex pa-1 pb-0">
      <template v-if="chatForwardMode && !isQuoted">
        <v-checkbox
            class="ma-0 pa-0 mr-2"
            label="Переслать"
            v-model="isForward"
            hide-details="auto"
            color="primary"
        ></v-checkbox>
      </template>
      <template v-if="chatCreateServiceMode && !isQuoted">
        <v-checkbox
            class="ma-0 pa-0 mr-2"
            label="Отправить в заявку"
            v-model="isCreateService"
            hide-details="auto"
        ></v-checkbox>
      </template>
      <span v-if="!isCurrentUserMessage || isQuoted">
          {{ message.displayName }}
      </span>
      <v-spacer/>
      <v-menu class="mr-3" offset-y v-if="message.inWork.length > 0">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              text
              dark
              x-small
              color="blue-grey lighten-2"
              v-bind="attrs"
              v-on="on"
          >
            Заявки
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item
              v-for="service in message.inWork"
              :key="'message_inWork_'+service.service.id"
              :color="serviceInWorkColor(service)"
              @click="goToService(service)"
          >
            <v-list-item-content>
              <v-list-item-title v-html="serviceInWorkTitle(service)"></v-list-item-title>
              <v-list-item-subtitle v-html="serviceInWorkSubTitle(service)"></v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
      <span class="mr-3" v-if="!isQuoted">
          {{ message.createdAt | formatDate }}
      </span>

      <v-menu offset-y v-if="!isQuoted">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              icon
              dark
              x-small
              color="blue-grey lighten-2"
              v-bind="attrs"
              v-on="on"
          >
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-list dense>
          <v-list-item @click="quotedMessage">
            <v-list-item-title>Ответить</v-list-item-title>
          </v-list-item>
          <v-list-item @click="forwardMessage">
            <v-list-item-title>Переслать</v-list-item-title>
          </v-list-item>
          <template v-if="isCurrentUserMessage && !message.isSystem">
            <v-divider></v-divider>
            <v-list-item
                @click="deleteMessage(message.id, message.activityId)">
              <v-list-item-title>Удалить</v-list-item-title>
            </v-list-item>
          </template>
        </v-list>
      </v-menu>
    </v-card-subtitle>
    <template v-if="message.quotedComment">
      <v-card-text
          class="text--primary pa-0"
          @click="scrollToQuotedComment()"
          v-if="!isQuoted"
      >
        <div class="quotedComment mt-1 ml-2 mr-2 pa-2">
          <chat-message
              :message="message.quotedComment"
              :is-quoted="true"
          ></chat-message>
        </div>
      </v-card-text>
    </template>
    <v-card-text class="text--primary pb-2">
      <div v-if="message.chatMessage.chatMessageTypeName === 'Chat'" v-html="message.body"></div>
      <div v-else-if="message.chatMessage.chatMessageTypeName === 'Image'">
        <v-row>
          <v-col cols="6" class="text-left">
            <v-img
                :max-height="isQuoted ? 50 : 100"
                :src="messageImgSrc(message)"
                :lazy-src="imageLoadSrc"
                v-on:click="showMultiMedia"
            ></v-img>
          </v-col>
          <v-col cols="6" class="text-right">
            <div v-html="message.chatMessage.caption">
            </div>

            <template v-if="!isQuoted">
              <v-btn
                  v-if="message.localStorage"
                  text
                  x-small
                  outlined
                  download
                  @click="downloadImage(message)"
                  target="_blank"
                  class="mt-2"
              >
                Скачать
              </v-btn>
              <v-btn
                  v-else
                  text
                  x-small
                  outlined
                  download
                  :href="messageImgSrc(message, true)"
                  target="_blank"
                  class="mt-2"
              >
                Скачать
              </v-btn>
            </template>
          </v-col>
        </v-row>
      </div>
      <div v-else-if="message.chatMessage.chatMessageTypeName === 'Audio'">
        <!--                <vuetify-audio :file="messageAudioSrc(message)" color="success" downloadable></vuetify-audio>-->
        <mini-audio
            :audio-source="messageAudioSrc(message)"
        ></mini-audio>
      </div>
      <div v-else-if="message.chatMessage.chatMessageTypeName === 'Ptt'">
        <!--                <vuetify-audio :file="messagePttSrc(message)" color="success" downloadable></vuetify-audio>-->
        <mini-audio
            :audio-source="messagePttSrc(message)"
        ></mini-audio>
      </div>
      <div v-else-if="message.chatMessage.chatMessageTypeName === 'Document'">
        <v-list-item
            dense
            class="pa-0"
        >
          <v-list-item-content class="justify-end">
            {{ message.localStorage ? message.localStorage.originalFileName : message.body }}
          </v-list-item-content>
          <v-list-item-action>
            <!--                        {{message.localStorage ? message.localStorage.originalFileName : message.body}}-->
            <v-btn
                icon
                outlined
                :href="messageDocumentSrc(message)"
                target="_blank"
            >
              <v-icon>
                mdi-download
              </v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </div>
      <div v-else-if="message.chatMessage.chatMessageTypeName === 'Video'">
        <video-player class="vjs-custom-skin"
                      ref="videoPlayer"
                      :options="{
                                    height: '360',
                                    autoplay: false,
                                    muted: false,
                                    language: 'ru',
                                    playbackRates: [0.7, 1.0, 1.5, 2.0],
                                    sources: [{
                                        type: 'video/mp4',
                                        // mp4
                                        src: message.body,

                                    }],
                                }"
                      :playsinline="true"
        >
        </video-player>
      </div>
      <div v-else v-html="message.body"></div>
    </v-card-text>
  </v-card>
</template>

<script>
import {ServiceStatus} from "@/enums/serviceStatus";

import 'video.js/dist/video-js.css'
import {videoPlayer} from 'vue-video-player'


export default {
  name: "ChatMessage",
  components: {
    // VuetifyAudio: () => import('vuetify-audio'),
    videoPlayer
  },
  created() {
    window.VueEvent.listen('clear-all-chat-create-service', this.clearSendToService);
    window.VueEvent.listen('clear-all-chat-forward', this.clearForward);
  },
  data() {
    return {
      imageLoadSrc: require('@/assets/loading.svg'),
      isForward: false,
      isCreateService: false,
      additionalActionsMenu: false
    }
  },
  watch: {
    isForward: function () {
      if (this.isForward) {
        this.$store.dispatch('addChatForwardMessage', this.message.id)
      } else {
        this.$store.dispatch('removeChatForwardMessage', this.message.id)
      }
    },
    isCreateService: function () {
      if (this.isCreateService) {
        this.$store.dispatch('addChatCreateServiceMessage', this.message.id)
      } else {
        this.$store.dispatch('removeChatCreateServiceMessage', this.message.id)
      }
    },
  },
  props: {
    message: Object,
    isQuoted: {
      type: Boolean,
      default: false
    },
    scrollToQuotedMessageFnc: Function,
    setQuotedMessageFnc: Function
  },
  computed: {
    currentUser() {
      return this.$store.getters.user
    },
    lastVisitedDate() {
      let self = this
      if (this.currentChat) {
        let attendee = this.currentChat.attendees.find(function (item) {
          return item.username === self.currentUser
        })
        if (attendee) {
          return attendee.lastVisited
        }

        return null
      }

      return null
    },
    currentChat() {
      return this.$store.getters.currentChat
    },
    isCurrentUserMessage() {
      return this.message.username === this.currentUser
    },
    bgColor() {
      if (this.isQuoted) {
        return 'transparent'
      }
      if (this.message.isSystem) {
        return 'grey lighten-2'
      }
      if (this.lastVisitedDate == null || this.lastVisitedDate < this.message.createdAt) {
        return 'deep-purple lighten-3'
      } else if (this.isCurrentUserMessage) {
        return 'deep-purple lighten-4'
      } else {
        return 'grey lighten-2'
      }
    },
    newMessageClass() {
      return this.lastVisitedDate == null || this.lastVisitedDate < this.message.createdAt ? 'new_message' : ''
    },
    additionalClass() {
      return this.message.isSystem ? 'message--system' : ''
    },
    chatForwardMode() {
      return this.$store.getters.chatForwardMode
    },
    chatCreateServiceMode() {
      return this.$store.getters.chatCreateServiceMode
    },
  },
  methods: {
    showMultiMedia() {
      window.VueEvent.fire('show-chat-message-multi-media', this.message)
    },
    forwardMessage() {
      this.additionalActionsMenu = false
      this.$store.dispatch('setChatForwardMode', true)
      this.isForward = true
    },
    quotedMessage() {
      this.additionalActionsMenu = false
      this.setQuotedMessageFnc(this.message.id)
    },
    scrollToQuotedComment() {
      this.scrollToQuotedMessageFnc(this.message.chatMessage.quotedMsgId)
    },
    messageImgSrc(message, toDownload = false) {
      return this._getMedia('image', message, toDownload)
    },
    messageAudioSrc(message) {
      return this._getMedia('audio', message)
      // return message.body
    },
    messagePttSrc(message) {
      return this._getMedia('ptt', message)
      // return message.body
    },
    messageDocumentSrc(message) {
      return this._getMedia('document', message)
      // return message.body
    },
    _getMedia(type, message, toDownload = false) {
      if (message.localStorage) {
        let url = `${process.env.VUE_APP_API_PATH}filestorage/activities/${this.currentChat.id}/${type}/${message.localStorage.localFileName}`
        if (type === 'image' && !toDownload) {
          url += '/thumbnail'
        }
        url += '?v=1.0'
        return url
      } else {
        return message.body
      }
    },
    deleteMessage(messageId, activityId) {
      this.$store.dispatch('deleteMessage', {
        messageId: messageId,
        activityId: activityId
      })
    },
    downloadImage(message) {
      let url = this.messageImgSrc(message, true)
      let fileName = message.localStorage.originalFileName
      this.downloadImg(url, fileName)
    },
    clearSendToService() {
      this.isCreateService = false
    },
    clearForward() {
      this.isForward = false
    },
    serviceInWorkColor(service) {
      return service.service.serviceStatus !== ServiceStatus.CLOSED ? 'red lighten-4' : 'green lighten-4'
    },
    serviceInWorkTitle(service) {
      return `Заявка №${service.service.number} Менеджер ${service.userDisplayName}`
    },
    serviceInWorkSubTitle(service) {
      return `Клиент ${service.service.client.name} Статус ${service.service.serviceStatus.name}`
    },
    goToService(service){
      const serviceId = service.service.id
      this.$router.push({
        name: 'ServicesCard',
        params: {serviceId}
      })
    }
  }
}
</script>

<style scoped lang="scss">
$textSize: 10px;
$quotedCommentTextSize: 10px;

.message--system {
  .v-card__subtitle {
    font-size: $textSize;
  }

  .v-card__text {
    font-size: $textSize;
  }
}

.quotedComment {
  font-size: $quotedCommentTextSize;
  background-color: #eceff17d !important;
  border-radius: 10px;
  box-shadow: 0 1px 1px rgb(0 0 0 / 25%), 0 1px 10px rgb(0 0 0 / 22%);
  border-left: #1E88E5 3px solid;
}

.v-application .highlight {
  background-color: #9FA8DA !important;
}
</style>